<div class="dx-card wide-card">
    <h4 class="content-block ap-green">Global HYCO Awards</h4>
    <dx-chart class="chartmargin" id="chart" [dataSource]="hycoAnalysisData">
        <dxi-series argumentField="hycoCategory" valueField="totalHyCOMMSCFD" name="Total HyCO MMSCFD" type="bar"
            color="#ffaa66">
        </dxi-series>
        <dxo-legend verticalAlignment="top" [visible]="true" horizontalAlignment="center"
            itemTextPosition="top"></dxo-legend>
        <dxi-value-axis position="left">
            <dxo-title text="Total Hyco (in MMSCFD)"></dxo-title>
        </dxi-value-axis>
    </dx-chart>
    <hr />

    <dx-data-grid class="fixGridHeight" id="globalHycoAwardsReportGrid" (onOptionChanged)="onOptionChanged($event)"
        [dataSource]="globalHycoAwardsReportData" [showRowLines]="true" [showColumnLines]="true" [showBorders]="true"
        [allowColumnResizing]="true" [rowAlternationEnabled]="true">
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-paging [enabled]="true" [pageSize]="20"></dxo-paging>
        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <dxo-sorting mode="multiple"></dxo-sorting>
        <dxo-search-panel [visible]="true"></dxo-search-panel>
        <dxo-export [enabled]="false"></dxo-export>
        <dxo-scrolling columnRenderingMode="virtual"></dxo-scrolling>
        <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
        <dxo-toolbar>
            <dxi-item name="groupPanel"></dxi-item>
            <dxi-item location="after">
                <dx-button text="Reset" stylingMode="contained" type="default" (onClick)="resetFilters()">
                </dx-button>
                <dx-button icon="exportxlsx" stylingMode="contained" type="default" text="Export to Excel"
                    (onClick)="exportExcel($event)">
                </dx-button>
            </dxi-item>
            <dxi-item name="searchPanel"></dxi-item>
        </dxo-toolbar>
        <dxo-pager [visible]="true" [allowedPageSizes]="allowedPageSizes" [showPageSizeSelector]="true"
            [showInfo]="true" [showNavigationButtons]="false"></dxo-pager>

        <dxi-column dataField="worldRegion" [width]="120"></dxi-column>
        <dxi-column dataField="siteId" [visible]="false" caption="Site Id" [width]="120"></dxi-column>
        <dxi-column dataField="productionFacilityId" caption="Facility ID " [width]="120"></dxi-column>
        <dxi-column dataField="countryName" caption="Country" [width]="100"></dxi-column>
        <dxi-column dataField="province" caption="State/Province" [width]="100"></dxi-column>
        <dxi-column dataField="city" [width]="100"></dxi-column>
        <dxi-column dataField="ownerLegalEntityName" caption="Owner Legal Entity Name" [width]="200"></dxi-column>
        <dxi-column dataField="ownersOfLegalEntityAndPercentOwned" caption="Owner Legal Entity and Percent Owned"
            [width]="200"></dxi-column>
        <dxi-column dataField="hycoCategory" [width]="150"></dxi-column>
        <dxi-column dataField="feedstockName" caption="Feedstock" [width]="150"></dxi-column>
        <dxi-column dataField="status" [width]="100"></dxi-column>
        <dxi-column dataField="awardYear" caption="Est Award Year" width="100"></dxi-column>
        <dxi-column dataField="onstreamYear" width="100"></dxi-column>
        <dxi-column dataField="hydrogen" caption="Hydrogen (kNm3/h)" width="100"></dxi-column>
        <dxi-column dataField="hydrogenMMSCFD" width="120" caption="Hydrogen (MMSCFD)"></dxi-column>
        <dxi-column dataField="carbonMonoxide" caption="Carbon Monoxide (kNm3/h)" width="100"></dxi-column>
        <dxi-column dataField="carbonMonoxideMMSCFD" width="120" caption="Carbon Monoxide (MMSCFD)"></dxi-column>
        <dxi-column dataField="syngas" caption="Syngas (kNm3/h)" width="100"></dxi-column>
        <dxi-column dataField="syngasMMSCFD" width="120" caption="Syngas (MMSCFD)"></dxi-column>
        <dxi-column dataField="totalHyco" caption="Total HyCO (kNm3/h)" width="100"></dxi-column>
        <dxi-column dataField="totalHycoMMSCFD" width="120" caption="Total HyCO (MMSCFD)"></dxi-column>
        <dxi-column dataField="endUseApplication" [width]="120"></dxi-column>
        <dxi-column dataField="productionFacilityNotes" caption="Notes" [width]="400"></dxi-column>
    </dx-data-grid>

    <dx-load-panel #dxLoadPanel shadingColor="rgba(0,0,0,0.4)" [visible]="isLoadPanelVisible" [showPane]="true"
        [shading]="false" [closeOnOutsideClick]="false">
    </dx-load-panel>
</div>